import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';


export default function AdvertiserDetails(props) {
  const { data } = props;

  const headers = (!data || ! data[0])? [] :Object.keys(data?.[0]).reduce((filtered, key)=>{
    if(key !== 'name')
      filtered.push(key)
    return filtered
  }, [])
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: '100%' }} size="small" aria-label="a dense table">
        <TableHead>
          <TableRow>
            <TableCell> Advertiser </TableCell>
            {headers?.map((header, index) => (
              <TableCell align="right" key={index} >{header}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data?.map((row) => (
            <TableRow
              key={row.name}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
              {headers?.map((header)=>(
                <TableCell key={row.name+'-'+header} align="right">{row[header]}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
